import axios from 'axios'
import {location} from './Location.js'

// const url = '/api/stream/'
const url = location('api/stream/')

class StreamService {

  // Get Posts
  static getStream() {
    return new Promise ((resolve,reject) => {
      axios.get(url).then((res) => {
        const STREAM = res.data
        resolve(STREAM)
      })
      .catch((err)=> {
        reject(err)
      })
    });
  }

}

export default StreamService
